import React, { ButtonHTMLAttributes } from "react";

export interface NormalBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  style?: "fill" | "line" | "ghost";
  disabled?: boolean;
}

const getNormalTailwind = (style: string, disabled: boolean) => {
  if (style === "fill") {
    if (disabled) {
      return "bg-[#eeeeee] text-[#888888] font-regular";
    }
    return "bg-[#6d2ef2] text-white font-bold hover:bg-[#5e2bc8]";
  }
  if (style === "line") {
    if (disabled) {
      return "border border-[#eeeeee] text-[#888888] font-medium bg-[#eeeeee]";
    }
    return "border border-[#eeeeee] text-[#666666] font-medium hover:bg-[#f7f7f7]";
  }
  if (style === "ghost") {
    return "text-[#888888] font-medium underline hover:text-[#6d2ef2]";
  }
  return "bg-[#6d2ef2] text-white font-bold";
};

const Normal: React.FC<NormalBtnProps> = ({
  style = "fill",
  disabled = false,
  ...props
}) => {
  const base =
    "flex items-center justify-center h-[32px] px-[12px] py-0 rounded-[4px] text-[14px] leading-[20px] tracking-[-0.28px] text-center transition-all duration-200 whitespace-nowrap";
  const tw = getNormalTailwind(style, disabled);

  return (
    <button
      className={`${base} ${tw}`}
      disabled={disabled}
      type="button"
      {...props}
    />
  );
};

export default Normal;
